import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/glide': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M252.8 148.6C252.8 157.4 251.2 166.3 249.4 175 243.6 202.8 237.8 230.8 232.1 258.6 230.7 264.9 223.8 263.5 218.4 263.5 194.6 263.5 187.9 237.5 187.9 218 187.9 188.7 199.1 149.9 226.4 134.9 230.7 132.4 235.6 130.7 240.5 130.7 251.9 130.7 252.8 139 252.8 148.6zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM384 267C384 261.9 363.2 229.3 358.5 227.5 356.3 226.6 351.3 225.2 348.9 225.2 325.8 225.2 310.2 235.7 290.7 246.7L290.2 246.2C294.5 216.8 304.8 189 304.8 158.8 304.8 114.2 281 96.1 237.3 96.1 165.6 96.1 129.3 166.9 129.3 219.6 129.3 274.3 161.3 304.6 215.6 304.6 223.1 304.6 222.5 304 222.5 306.9 212 387.2 166 389.8 166 365.8 166 341.4 194 329.3 194.3 327.8 194.1 320.2 165 310.6 157.6 310.6 136.5 310.6 124.9 343.6 124.9 361.2 124.9 393.5 145.3 415.9 178.2 415.9 226.4 415.9 261.6 366.2 272.5 324.2 281.9 286.5 279.5 284.8 284.8 282.1 304.8 272 320.6 265.3 343.2 265.3 354.3 265.3 362.2 267.6 379.9 270.5 381.7 270.6 384 268.8 384 267z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/glide.js
// module id = e1ry
// module chunks = 144